import {h} from 'preact';
import * as BaseComp from 'components/bolt/text/text.js';
import { observeScroll, unobserveScroll } from 'utils/scrollObserver';

export default class Text extends BaseComp.default {
	componentDidMount(...args) {
		super.componentDidMount?.(...args);
		observeScroll(this.base);
	}

	componentWillUnmount(...args) {
		super.componentWillUnmount?.(...args);
		unobserveScroll(this.base);
	}
}